<template>
  <v-container fluid fill-height>
    <v-toolbar :color="expertColor" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>  
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5>
        <v-card class="elevation-12">
          <v-toolbar dark :color="toolbarColor">
            <v-toolbar-title>Login</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <v-text-field
                  prepend-icon="person"
                  v-validate="'required'"
                  :error-messages="errors.collect('phone')"
                  data-vv-name="phone"
                  v-model="phone"
                  label="Phone No. (Start with your country code +...)"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
                <v-text-field
                  prepend-icon="lock"
                  v-validate="'required'"
                  :error-messages="errors.collect('password')"
                  data-vv-name="password"
                  v-model="password"
                  label="Password"
                  type="password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12>
                <span style="color:red">{{err_msg}}</span>
              </v-flex>
              <v-flex xs12 sm6 class="pass-reset">
                <v-btn color="primary" flat :to="`/password/reset`">Forgot Password</v-btn>
              </v-flex>
              <v-flex xs12 sm6>
                <v-spacer></v-spacer>
                <v-btn @click="login" :color="toolbarColor" class="right" dark>Login</v-btn>
              </v-flex>
              <v-flex xs12 sm12>
                <hr>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { webUrl } from '@/common/index'
import { mapGetters } from 'vuex';
export default {
  name: "FundiAdminLoginPage",
  components: {},
  computed: {
    ...mapGetters(['webUrl'])
  },
  data() {
    return {
      expertColor: "white",
      toolbarColor: null,
      phone: null,
      password: null,
      err_msg: null,
      loading: false
    };
  },
  methods: {
    navigateHome() {
      window.location = this.webUrl;
    },
    login() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          const data = {
            username: this.phone,
            password: this.password
          };

          const self = this;
          const res = this.$store
            .dispatch("post", { url: "/user/login", data })
            .then(res => {
              const user = res.user;
              if (res.state == true) {
                localStorage.setItem("token", res.token);
                self.$store.commit("setUser", res.user);
                this.$router.push("/dashboard");
                self.loading = false;
                self.password = null;
                self.phone = null;
                res.err_msg = null;
              } else {
                this.err_msg = res.msg;
              }
            })
            .finally(() => {
              // stuffs happens here
            });
        }
      });
    }
  },
  created() {
    this.toolbarColor = "blue darken-1";
  }
};
</script>

<style scoped>
  .logo-img {
    cursor: pointer;
  }
</style>
